import { render, staticRenderFns } from "./RowField.vue?vue&type=template&id=80d704ba"
import script from "./RowField.vue?vue&type=script&lang=js"
export * from "./RowField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports